import { jsx as _jsx } from "react/jsx-runtime";
export function SegmentedControl({ label, options, value, onChange }) {
    return (_jsx("div", { role: "group", "aria-label": label, "data-segmented": "", style: {
            display: "inline-flex",
            padding: "var(--space-025)",
            borderRadius: "var(--radius-panel)",
            background: "var(--tone)",
        }, children: options.map((option) => {
            const on = option.id === value;
            return (_jsx("button", { type: "button", "data-segment": option.id, "aria-pressed": on, disabled: option.disabled === true, onClick: () => onChange(option.id), style: {
                    // knowledge-page design-spec §3.3 / §4.3: 30px tall, 64px minimum width.
                    height: "30px",
                    minWidth: "64px",
                    padding: "0 var(--space-15)",
                    margin: 0,
                    border: "none",
                    borderRadius: "var(--radius-control)",
                    fontFamily: "var(--font-sans)",
                    fontSize: "var(--type-small-size)",
                    fontWeight: on ? "var(--type-body-weight-current)" : "var(--type-body-weight-strong)",
                    textAlign: "center",
                    color: on ? "var(--ink-1)" : "var(--segment-ink, var(--ink-2))",
                    background: on ? "var(--float)" : "transparent",
                    // knowledge-page design-spec §4.3: the pressed option's edge and lift.
                    boxShadow: on ? "0 0 0 1px var(--line), 0 1px 2px rgba(29, 41, 37, 0.06)" : "none",
                    cursor: option.disabled === true ? "default" : "pointer",
                    transitionProperty: "color, background-color",
                    transitionDuration: "var(--dur-fast)",
                    transitionTimingFunction: "var(--ease-out)",
                }, children: option.label }, option.id));
        }) }));
}
